import React, { useEffect, useState } from "react";
import { Flex, Image, Icon } from "@chakra-ui/react";
import {IoNotificationsOutline} from 'react-icons/io5';
import { useNavigate } from "react-router-dom";
import api from "../servicos/Api";


const Header = () => {
    var navigate = useNavigate();
    const [notificacao, setCount] = useState({qtd: 0});

    const getNotificacoesHeader = async () => {
        var count = 0;
        const response = await api.post('/login_app/get_notificacoes');
        if(response.data.error === false){
            response.data.data.map(n => ( !n.visualizado  ? count += 1 : '' ));
            setCount({qtd:count});
        }
    };
    useEffect(() => {
        getNotificacoesHeader();
    }, []);

    return(
        <Flex p='4' direction='row' justifyContent='space-between' alignItems='center'>
            <Image h='40px' src='https://conselho.gremio.net/assets/img/logo-conselho-p.png'/>
            <div>
                {notificacao.qtd > 0 ?
                <div 
                    className="notification-alert"
                        style={{
                                backgroundColor : '#00a0e6'
                                , minWidth : '18px'
                                , minHeight : '18px'
                                , height : 'auto'
                                , width : 'auto'
                                , maxWidth : '30px'
                                , maxHeight : '30px'
                                // , padding : '5px'                                
                                , borderRadius : '15px'
                                , position : 'absolute'
                                , marginLeft : '10px'
                                , marginTop : '-10px'
                                , fontSize : '12px'
                                , fontWeight : 700
                                , color : 'white'
                                , textAlign : 'center'}}
                    >
                        {notificacao.qtd}
                    </div>
                    : ''
                }
                <Icon boxSize='5' cursor='pointer' onClick={() => navigate('/notificacoes')} as={IoNotificationsOutline}/>
               
            </div>
           
        </Flex>
    );    
};

export default Header;